import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Box,
  CircularProgress,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import MDButton from "components/MDButton";

const toEmbedUrl = (url) => {
  // Google Drive → /preview
  const driveMatch = url.match(
    /https?:\/\/drive\.google\.com\/file\/d\/([^/]+)\/view/
  );
  if (driveMatch) {
    return `https://drive.google.com/file/d/${driveMatch[1]}/preview`;
  }
  // Dropbox → ?raw=1
  const dropboxMatch = url.match(
    /https?:\/\/(www\.)?dropbox\.com\/s\/([^/]+)\/(.+)/
  );
  if (dropboxMatch) {
    const base = url.replace(/(\?raw=0|(\?dl=0))?$/, "");
    return base.includes("?raw=1") ? base : `${base}?raw=1`;
  }
  // OneDrive → switch /view to /embed
  if (url.includes("onedrive.live.com")) {
    return url.replace(/\/view(\?.*)?$/, "/embed");
  }
  return url;
};

export default function SubscriptionContract({ pdfUrl, onAgree }) {
  const [agreed, setAgreed] = useState(false);
  const [embedUrl, setEmbedUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    try {
      const url = toEmbedUrl(pdfUrl);
      setEmbedUrl(url);
      setLoading(false);
    } catch (err) {
      setError("Failed to process URL");
      setLoading(false);
    }
  }, [pdfUrl]);

  if (loading) {
    return (
      <Box
        height={600}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      maxWidth="500px"
      height="100vh"
      margin="auto"
    >
      <Box
        flex="0 0 70%"
        width="100%"
        mb={2}
        sx={{ border: "1px solid #ccc", borderRadius: 1 }}
      >
        <iframe
          src={embedUrl}
          title="Document"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </Box>

      <FormControlLabel
        control={
          <Checkbox
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            color="primary"
          />
        }
        label="I have read and agree to the Terms & Conditions"
      />

      <MDButton
        variant="gradient"
        color="success"
        disabled={!agreed}
        onClick={onAgree}
        sx={{ mt: 1 }}
      >
        Continue
      </MDButton>
    </Box>
  );
}

SubscriptionContract.propTypes = {
  pdfUrl: PropTypes.string.isRequired,
  onAgree: PropTypes.func.isRequired,
};
